// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1sPwN","colMaxWidth":"Table_colMaxWidth__1L1Bn"};